import type { CreateSiteOrderRequest, SiteOrderSummary, SiteOrderView } from '@/types/api';
import { apiRequest } from '@/api/client';

/** A new site ordered in one go (ADR-0059): the domain bought, the site made on it. */
export const siteOrdersApi = {
  /** Pays for the domain in this request; the same key is the same order, paid once. */
  create: (input: CreateSiteOrderRequest, key: string) => apiRequest<SiteOrderView>('/site-orders', { method: 'POST', body: input, idempotencyKey: key }),

  get: (id: string) => apiRequest<SiteOrderView>(`/site-orders/${id}`),

  /** Orders under way and those finished in the last day. */
  recent: () => apiRequest<SiteOrderSummary[]>('/site-orders'),
};
